import { sendWebviewRadar } from 'reactApp/utils/sendWebviewRadar';

export const sendWebviewAnalytics = (t: string, isMobilePayAvailable: boolean): void => {
    sendWebviewRadar('quota_tariffs', t, isMobilePayAvailable);
};
